import { call, put, takeLatest } from "redux-saga/effects";
import { listCreditLinesRequest, productCreditLinesListRequest } from "middleware/creditLines";
import * as i18n from "util/i18n";
import { types, actions } from "reducers/creditLines";
import { actions as notificationActions } from "reducers/notification";

const sagas = [takeLatest(types.LIST_REQUEST, listRequest), takeLatest(types.PRODUCT_LIST_REQUEST, productListRequest)];

export default sagas;

function* listRequest() {
    const response = yield call(listCreditLinesRequest);

    if (response.type === "W") {
        yield put(actions.listFailure());
        yield put(notificationActions.showNotification(i18n.get("returnCode.BAK001E"), "error", ["creditLines"]));
    } else {
        const { creditLines: responseCreditLines, total } = response.data.data;
        yield put(actions.listSuccess(responseCreditLines, total));
    }
}

function* productListRequest({ creditLineNumber }) {
    const response = yield call(productCreditLinesListRequest, creditLineNumber);

    if (response.type === "W") {
        yield put(actions.productListFailure());
        yield put(
            notificationActions.showNotification(i18n.get("returnCode.BAK001E"), "error", ["creditLinesDetails"]),
        );
    } else {
        const { creditLines: productCreditLineList } = response.data.data;
        yield put(actions.productListSuccess(productCreditLineList));
    }
}
